import React from "react";
import { Typography, Table, Button, Modal } from "antd";
import { useIntl } from "react-intl";
import { CloseOutlined } from "@ant-design/icons";

const { Text, Title } = Typography;

const BtlErrorsTable = (props) => {
  const { btlUploadErrors, onHide, visible } = props;

  const intl = useIntl();

  const columns = [
    {
      title: intl.formatMessage({
        id: "app.prospectuses.prospectus_id",
      }),
      width: "200px",
      render(text, record) {
        return <Text>{record["prospectus_serial"]}</Text>;
      },
    },

    {
      title: intl.formatMessage({
        id: "app.prospectuses.line_number",
      }),
      width: "200px",
      render(text, record) {
        return <Text>{record["line_number"]}</Text>;
      },
    },
    {
      title: intl.formatMessage({
        id: "app.prospectuses.error",
      }),
      width: "200px",
      render(text, record) {
        return (
          <Text>
            {intl.formatMessage({
              id: `app.prospectuses.error_${record["error"]}`,
            })}
          </Text>
        );
      },
    },
  ];

  return (
    <Modal
      closable={false}
      footer={null}
      maskClosable={false}
      title={null}
      width={"fit-content"}
      style={{ top: 20, padding: 0 }}
      styles={{
        body: {
          padding: 0,
        },
      }}
      open={visible}
      destroyOnClose={true}
    >
      <div>
        <div className="header" style={{ height: "40px" }}>
          <Button
            style={{ position: "absolute", left: 10, top: 10 }}
            className="closeBtn"
            type="text"
            shape="circle"
            icon={<CloseOutlined />}
            onClick={onHide}
          />
        </div>
        <Title level={3} ellipsis style={{ margin: "0px 20px 10px 20px" }}>
          {intl.formatMessage({
            id: "app.prospectuses.btlErrorsTableTitle",
          })}
        </Title>
        <Table
          bordered
          pagination={false}
          columns={columns}
          dataSource={btlUploadErrors}
          rowKey={(record) => record.prospectus_serial}
          scroll={{ y: window.innerHeight - 210 }}
        />
      </div>
    </Modal>
  );
};

export default BtlErrorsTable;
